import React from "react";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Link } from "react-router-dom";
import Typography from "@mui/material/Typography";
import Image from "mui-image";
import banner from "../../../assets/home-hero-banner.webp";

const Hero = () => {
  return (
    <section id="hero" style={{ backgroundColor: "#F8F7FF" }}>
      <Container maxWidth="lg" sx={{ paddingTop: "160px" }}>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={5}>
              <Typography
                variant="h1"
                gutterBottom
                sx={{ textAlign: { xs: "center", sm: "center", md: "left" } }}
              >
                Engineering the next best thing for
                <span className="heading-red">the digital world</span>
              </Typography>
              <Typography
                variant="body1"
                gutterBottom
                sx={{
                  textAlign: { xs: "center", sm: "center", md: "left" },
                  mb: 3.7,
                }}
              >
                Agile in mind, spirit, and speed.
              </Typography>

              <Box
                sx={{
                  textAlign: { xs: "center", sm: "center", md: "left" },
                  mb: 3.7,
                }}
              >
                <Link to="/contact" style={{ textDecoration: "none" }}>
                  <div className="button_slide_hero slide_down_hero">
                    Scale your dream team{" "}
                  </div>
                </Link>
              </Box>
            </Grid>
            <Grid item xs={12} md={7}>
              <Image src={banner} alt="banner" width="100%" height="auto" />
            </Grid>
          </Grid>
        </Box>
      </Container>
    </section>
  );
};

export default Hero;
